import React, { Component } from 'react'
import { Form, Button, TextArea, Header } from 'semantic-ui-react'
import Recaptcha from 'react-recaptcha'

export default class ContactForm extends Component {
  state = {
    verified: false,
  }

  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  clearForm = () =>
    this.setState({
      firstName: '',
      lastName: '',
      email: '',
      body: '',
    })

  verifyCallback = response => {
    console.log(response)
    this.setState({ verificationResponse: response })
    this.setState({ verified: true })
    this.verificationTimeout = setTimeout(this.expireValidation, 120000)
  }

  expireValidation = () => {
    this.setState({ verificationResponse: null })
    this.setState({ verified: false })
  }

  submitForm = async data => {
    try {
      console.log(this.state)
      const response = await fetch(this.props.submitUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(this.state),
        mode: this.props.cors ? 'cors' : undefined,
      })
      console.log(response)
      await this.clearForm
    } catch (error) {
      console.error(error)
    }
  }

  render() {
    return (
      <div id="email-form">
        <Header as="h2" textAlign="center">
          - Contact Me -
        </Header>
        <Form onSubmit={this.submitForm}>
          <Form.Group widths="equal">
            <Form.Input
              required
              fluid
              name="firstName"
              label="First name"
              placeholder="First name"
              value={this.state.firstName}
              onChange={this.handleChange}
            />
            <Form.Input
              required
              fluid
              name="lastName"
              label="Last name"
              placeholder="Last name"
              value={this.state.lastName}
              onChange={this.handleChange}
            />
          </Form.Group>
          <Form.Input
            required
            name="email"
            onChange={this.handleChange}
            label="Your Email"
            type="email"
            placeholder="example@example.com"
            value={this.state.email}
          />
          <Form.Field
            required
            name="body"
            control={TextArea}
            label="Body"
            placeholder="Ask us anything you'd like to know..."
            value={this.state.body}
            onChange={this.handleChange}
          />

          {/* Recaptcha and submit */}
          <div className="flex-centered">
            <Recaptcha
              sitekey={this.props.siteKey}
              render="explicit"
              verifyCallback={this.verifyCallback}
            />
            <div className="centered spaced">
              {this.state.verified && <Button type="submit">Submit</Button>}
              {
                <Button type="clear" onClick={this.clearForm}>
                  Clear
                </Button>
              }
            </div>
          </div>
        </Form>
      </div>
    )
  }
}
